var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_797",
    "data-name": "Rectangle 797",
    width: 30,
    height: 30,
    transform: "translate(1145.151 993.566)",
    fill: "none",
    stroke: "#b7b5b6",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_58",
    "data-name": "Mask Group 58",
    transform: "translate(-1145.151 -993.566)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "upload_FILL0_wght400_GRAD0_opsz48",
    d: "M162.324,280.792A2.383,2.383,0,0,1,160,278.468v-5.539h2.324v5.539h20.143v-5.539h2.324v5.539a2.383,2.383,0,0,1-2.324,2.324Zm8.91-5.927V260.494l-4.649,4.648-1.666-1.666L172.4,256l7.476,7.476-1.666,1.666-4.648-4.648v14.372Z",
    transform: "translate(987.79 740.17)",
    fill: "#0073b2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.f82193efb9be6d10fc84dfd4f91d8634.svg";
export { ForwardRef as ReactComponent };